import React, { Fragment } from 'react';
import { Text, View, StyleSheet, } from '@react-pdf/renderer';

const borderColor = '#3778C2'
const styles = StyleSheet.create({
    row: {
        flexDirection: 'row',
        borderBottomColor: '#3778C2',
        borderBottomWidth: 1,
        alignItems: 'center',
        fontStyle: 'bold',
    },
    description: {
        width: '40%',
        textAlign: 'left',
        borderRightColor: borderColor,
        borderRightWidth: 1,
        paddingLeft: 8,
    },
    value: {
        width: '60%',
        flexDirection: 'column',
        borderRightColor: borderColor,
        textAlign: 'right',
        paddingRight: 8,
        paddingLeft: 4
    }
});

const ReceiptBodyInvoice = ({ receipt }) => (
    <Fragment>
        <View style={styles.row}>
            <Text style={styles.description}>Vergi Dairesi</Text>
            <Text style={styles.value}>{receipt.taxInfo}</Text>
        </View>
        <View style={styles.row}>
            <Text style={styles.description}>TCSN / Mersis No</Text>
            <Text style={styles.value}>{receipt.tcsnMersisNo}</Text>
        </View>
        <View style={styles.row}>
            <Text style={styles.description}>Temsilcinin Ticaret Ünvanı</Text>
            <Text style={styles.value}>{receipt.temsilciTicaretUnvani}</Text>
        </View>
        <View style={styles.row}>
            <Text style={styles.description}>Fatura Adresi</Text>
            <Text style={styles.value}>{receipt.billAddress}</Text>
        </View>
        <View style={styles.row}>
            <Text style={styles.description}>Düzenleme Tarihi</Text>
            <Text style={styles.value}>{receipt.generationDate}</Text>
        </View>
        <View style={styles.row}>
            <Text style={styles.description}>İşlem Türü</Text>
            <Text style={styles.value}>{receipt.transactionType}</Text>
        </View>
        <View style={styles.row}>
            <Text style={styles.description}>İşlem Yeri</Text>
            <Text style={styles.value}>PAYCELL</Text>
        </View>
        <View style={styles.row}>
            <Text style={styles.description}>BSMV Matrahı</Text>
            <Text style={styles.value}>₺ {receipt.bsmvMat}</Text>
        </View>
        <View style={styles.row}>
            <Text style={styles.description}>BSMV</Text>
            <Text style={styles.value}>₺ {receipt.bsmv}</Text>
        </View>
        <View style={styles.row}>
            <Text style={styles.description}>Referans No</Text>
            <Text style={styles.value}>{receipt.transactionId}</Text>
        </View>
        <View style={styles.row}>
            <Text style={styles.description}>İşlem Tarihi</Text>
            <Text style={styles.value}>{receipt.transactionDate}</Text>
        </View>
        <View style={styles.row}>
            <Text style={styles.description}>Kurum Adı</Text>
            <Text style={styles.value}>{receipt.corpName}</Text>
        </View>
        <View style={styles.row}>
            <Text style={styles.description}>Abone Numarası</Text>
            <Text style={styles.value}>{receipt.subscriberNo}</Text>
        </View>
        <View style={styles.row}>
            <Text style={styles.description}>Fatura Numarası</Text>
            <Text style={styles.value}>{receipt.invoiceNo}</Text>
        </View>
        <View style={styles.row}>
            <Text style={styles.description}>Son Odeme Tarihi</Text>
            <Text style={styles.value}>{receipt.invoiceDueDate}</Text>
        </View>
        <View style={styles.row}>
            <Text style={styles.description}>Ödeme Türü</Text>
            <Text style={styles.value}>{receipt.paymentType}</Text>
        </View>
        <View style={styles.row}>
            <Text style={styles.description}>Kredi Kart Numarası(Maskeli)</Text>
            <Text style={styles.value}>{receipt.creditCardNumber}</Text>
        </View>
        <View style={styles.row}>
            <Text style={styles.description}>Fatura Tutarı</Text>
            <Text style={styles.value}>₺ {receipt.paymentAmount}</Text>
        </View>
        <View style={styles.row}>
            <Text style={styles.description}>İşlem Ücreti</Text>
            <Text style={styles.value}>₺ {receipt.commissionAmount}</Text>
        </View>

        {receipt.donationAmount ? (
            <View style={styles.row}>
                <Text style={styles.description}>Bağış Tutarı</Text>
                <Text style={styles.value}>₺ {receipt.donationAmount}</Text>
            </View>) : (<View />)
        }

        <View style={styles.row}>
            <Text style={styles.description}>Toplam Tutar</Text>
            <Text style={styles.value}>₺ {receipt.totalPaymentAmount}</Text>
        </View>
    </Fragment>
);

export default ReceiptBodyInvoice;
